import SliderManager from "./SliderManager.js";

const toolsSlider = new SliderManager({
  selector: ".tools__list",
  splideOptions: {
    type: "loop",
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: false,
    fixedWidth: "282px",
    autoWidth: false,
    trimSpace: false,
    updateOnMove: true,
    waitForTransition: true,
    gap: "16px",
    mediaQuery: "min"
  },
  createCondition: () => window.innerWidth < 768,
  globalVarName: "toolsSlider",
  resizeDelay: 250,
  dynamicWrapper: {
    trackClass: "tools__slider-track",
    itemClass: "tool-card",
  },
});

toolsSlider.init();
